// Suggested Items — renders DataGate `suggestedItems` for the current product as
// a pc-card grid with Quick-View + Add-to-Cart. Shares all logic with the
// Alternative Products widget (see shared/relatedProducts.js).
//
// Mount (read from the TARGET element, not the script tag):
//   #parts-suggested-products  OR  [data-parts-suggested-products] — container
//   data-sku-selector="#product-sku"  (optional; overrides the SKU source)
//   data-limit="6"                     (optional; number to fetch)
//   data-title="Suggested items"       (optional; section heading)

import { createRelatedWidget } from '../shared/relatedProducts.js';

var widget = createRelatedWidget({
	id: 'suggested-products',
	containerId: 'parts-suggested-products',
	dataAttr: 'data-parts-suggested-products',
	endpointFor: function (sku, limit) {
		return '/api/parts/' + encodeURIComponent(sku) + '/suggested?limit=' + limit;
	},
	responseKey: 'suggested',
	defaultTitle: 'Suggested Parts',
	loadingText: 'Loading suggested parts...',
	emptyText: 'No suggested parts found for this part.',
});

export var init = widget.init;
export var id = widget.id;
